import React from "react";
import { Button, ButtonToolbar, Modal } from "react-bootstrap";

function DeleteModal({
  isLoading,
  isDeleteModal,
  handleDeleteHide,
  title,
  message,
  saveButtonLabel,
  onClickOfSaveButton,
  onClickOfCancelButton,
  cancelButtonLabel,
}) {
  return (
    <>
      <Modal
        show={isDeleteModal}
        onHide={handleDeleteHide}
        dialogClassName="modal-90w"
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-lg">{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <span>{message}</span>
        </Modal.Body>
        <Modal.Footer>
          <ButtonToolbar className="d-flex justify-content-end button-wrap">
            <Button
              variant="btn btn-success mr-3"
              onClick={onClickOfSaveButton}
              disabled={isLoading}
            >
              {saveButtonLabel}
              {isLoading && (
                <span className=" mr-3 ml-3 spinner spinner-white"></span>
              )}
            </Button>
            <Button
              variant="btn btn-light-dark"
              onClick={onClickOfCancelButton}
            >
              {cancelButtonLabel}
            </Button>
          </ButtonToolbar>
        </Modal.Footer>
      </Modal>
    </>
  );
}
export default DeleteModal;
